import React from "react";
import NotesIcon from "@mui/icons-material/Notes";
import { Container, RightContainer, Title } from "./styled";
import { useSelector } from "react-redux";
import moment from "moment";

const DataRevisao1Result = () => {
  const thisCard = useSelector((state) => state.card);

  const formattedDate = thisCard.dateRevisao1
    ? moment(thisCard.dateRevisao1).isValid()
      ? moment(thisCard.dateRevisao1).format("DD/MM/YYYY")
      : "-"
    : "";
  return (
    <Container>
      <NotesIcon fontSize="small" />
      <RightContainer>
        <Title>Data Revisão 1</Title>
        <p>{formattedDate}</p>
      </RightContainer>
    </Container>
  );
};

export default DataRevisao1Result;
